'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _CellInfoIconsBlock = require('../components/CellInfoIconsBlock/CellInfoIconsBlock');var _CellInfoIconsBlock2 = _interopRequireDefault(_CellInfoIconsBlock);
var _CellPhotoBlock = require('../components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);

var _parkingConverter = require('../../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);

var _OMPropertyDynamicPreviewCell = require('./OMPropertyDynamicPreviewCell.scss');var styles = _interopRequireWildcard(_OMPropertyDynamicPreviewCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Helpers
// Components
var OMPropertyDynamicPreviewCell = function OMPropertyDynamicPreviewCell(props) {var _cx;var
  location = props.routeData.location;
  var parkingSpots = (0, _parkingConverter2.default)(props.parkingSpots);
  var isForeign = location === 'foreign_property' || location === 'foreign_publish';

  return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(
        styles.propertyRow, (_cx = {}, _cx[
        styles.foreignPropertyRow] = isForeign, _cx)) },


      _react2.default.createElement(_CellPhotoBlock2.default, {
        locale: props.locale,
        isRtl: props.isRtl,
        photo: props.photo,
        price: props.price,
        images: props.images,
        searchOption: props.searchOption,
        currency: props.currency && props.currency.value,
        translate: props.translate,
        className: isForeign ? 'foreignDynamic' : 'dynamic',
        isDynamic: true,
        withoutFavoriteIcon: true,
        withoutPagination: true,
        withoutLoop: true }),


      _react2.default.createElement('div', { className: styles.propertyDescription },
        _react2.default.createElement('div', { className: styles.propertyType },
          props.propertyType || _react2.default.createElement('span', { className: styles.emptyData })),


        _react2.default.createElement('div', { property: 'address', className: styles.propertyAddress },
          _react2.default.createElement('div', null, props.address || _react2.default.createElement('span', { className: styles.emptyData })),
          _react2.default.createElement('div', null, props.city || _react2.default.createElement('span', { className: styles.emptyData }))),


        _react2.default.createElement(_CellInfoIconsBlock2.default, {
          locale: props.locale,
          area: props.area,
          floor: props.groundFloor ? props.groundFloorTitle : props.floor,
          parkingSpots: parkingSpots,
          rooms: props.rooms }))));




}; // Styles
// Modules
OMPropertyDynamicPreviewCell.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  propertyType: _propTypes2.default.string,
  searchOption: _propTypes2.default.string,
  photo: _propTypes2.default.string,
  images: _propTypes2.default.array,
  price: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  address: _propTypes2.default.string,
  rooms: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  parkingSpots: _propTypes2.default.object,
  city: _propTypes2.default.string,
  area: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  floor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  groundFloor: _propTypes2.default.bool,
  groundFloorTitle: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  routeData: _propTypes2.default.object,
  currency: _propTypes2.default.object };exports.default =


OMPropertyDynamicPreviewCell;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMPropertyDynamicPreviewCell/OMPropertyDynamicPreviewCell.js
// module id = 2725
// module chunks = 0